import React, { useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import "./index.css";

import tituloCarta from "../../assets/images/png/tituloCarta.png";
import setaDireita from "../../assets/images/svg/setaDireita.svg";
import setaEsquerda from "../../assets/images/svg/setaEsquerda.svg";
import carta0a from "../../assets/images/png/carta0a.png";
import carta1a from "../../assets/images/png/carta1a.png";
import carta2a from "../../assets/images/png/carta2a.png";
import carta3a from "../../assets/images/png/carta3a.png";
import carta4a from "../../assets/images/png/carta4a.png";
import carta5a from "../../assets/images/png/carta5a.png";
import carta0b from "../../assets/images/png/carta0b.png";
import carta1b from "../../assets/images/png/carta1b.png";
import carta2b from "../../assets/images/png/carta2b.png";
import carta3b from "../../assets/images/png/carta3b.png";
import carta4b from "../../assets/images/png/carta4b.png";
import carta5b from "../../assets/images/png/carta5b.png";
 


 
const cartas = [
  { front: carta0a, back: carta0b },
  { front: carta1a, back: carta1b },
  { front: carta2a, back: carta2b },
  { front: carta3a, back: carta3b },
  { front: carta4a, back: carta4b },
  { front: carta5a, back: carta5b },
];

export default function Cartas() {
  const navigate = useNavigate();
  const [flippedCards, setFlippedCards] = useState({});
  const swiper = useRef(null);

  const handleCardClick = (index) => {
    setFlippedCards((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const Cards = [
    {
      estrelas: 5,
      comentario:
        "Experiência incrível! Meus filhos se divertiram muito e não queriam ir embora. O lugar é super seguro e a equipe muito atenciosa. Recomendo fortemente!",
      nome: "João da Silva",
    },
    {
      estrelas: 5,
      comentario:
        "Experiência incrível! Meus filhos se divertiram muito e não queriam ir embora. O lugar é super seguro e a equipe muito atenciosa. Recomendo fortemente!",
      nome: "João da Silva",
    },
    {
      estrelas: 5,
      comentario:
        "Experiência incrível! Meus filhos se divertiram muito e não queriam ir embora. O lugar é super seguro e a equipe muito atenciosa. Recomendo fortemente!",
      nome: "João da Silva",
    },
    {
      estrelas: 5,
      comentario:
        "Experiência incrível! Meus filhos se divertiram muito e não queriam ir embora. O lugar é super seguro e a equipe muito atenciosa. Recomendo fortemente!",
      nome: "João da Silva",
    },
    {
      estrelas: 4,
      comentario:
        "Ótimo lugar para as crianças se divertirem. Os brinquedos são bem conservados e o ambiente é muito limpo. Só achei o preço um pouco alto.",
      nome: "Maria Oliveira",
    },
    {
      estrelas: 3,
      comentario:
        "O espaço é bom e as crianças gostaram bastante. Porém, no dia que fomos estava muito cheio e tivemos que esperar bastante para usar alguns brinquedos.",
      nome: "Pedro Santos",
    },
    {
      estrelas: 2,
      comentario:
        "Achei que poderia ter mais opções de brinquedos para crianças menores. O espaço é um pouco limitado e os monitores nem sempre estavam atentos.",
      nome: "Ana Costa",
    },
    {
      estrelas: 1,
      comentario:
        "Decepcionante. Preço alto para poucas atrações, funcionários despreparados e brinquedos que precisam de manutenção. Não voltarei.",
      nome: "Carlos Ferreira",
    },
  ];
  const handlePrevClick = () => {
    swiper.current?.swiper.slidePrev();
  };

  const handleNextClick = () => {
    swiper.current?.swiper.slideNext();
  };

  return (
    <div className="cartas-container">
      <div className="container pt-4">
        <div className="d-flex align-items-center justify-content-center">
          <img
            className="setaCards"
            src={setaEsquerda}
            alt="Previous card slide"
            onClick={handlePrevClick}
          />
          <img
            style={{ width: "50%" }}
            src={tituloCarta}
            alt={`titulo  meet the Z Gang`}
          />
          <img
            className="setaCards"
            src={setaDireita}
            alt="Next card slide"
            onClick={handleNextClick}
          />
        </div>
        <Swiper
          ref={swiper}
          pagination={{
            clickable: true,
          }}
          loop={true}
          slidesPerView={1}
          spaceBetween={10}
        
          autoplay={{
            delay: 10000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
          modules={[Pagination, Navigation, Autoplay]}
          className="mySwiper"
        >
          {cartas.map((carta, index) => (
            <SwiperSlide key={index}>
              <div
                className={`card-container ${
                  flippedCards[index] ? "flipped" : ""
                }`}
                onClick={() => handleCardClick(index)}
              >
                <div className="card-inner">
                  <div className="card-front">
                    <img src={carta.front} alt={`Carta ${index + 1}`} />
                  </div>
                  <div className="card-back">
                    <img src={carta.back} alt={`Carta ${index + 1} verso`} />
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
